<div class="labels">
  <ds-search-label-loader *ngFor="let appliedFilter of appliedFilters$ | async"
                          [appliedFilter]="appliedFilter"
                          [inPlaceSearch]="inPlaceSearch">
  </ds-search-label-loader>
</div>
